import { Event } from './editor/event-editor';
import { GeneralDataProperties } from './data-viewer';

const registry = {
	"event" : (data) => <Event data={ data } />,
	"booking" : (data) => <GeneralDataProperties data={ data } />,
	"payment": (data) => <GeneralDataProperties data={ data } />,
	"ticket": (data) => <GeneralDataProperties data={ data } />
};
export default registry;